import { Field, StepHeader, NavButtons } from "../common";
import { useSession } from "../../lib/session";
import { InvestigationPanel } from "../InvestigationPanel";

export default function InvestigationStep() {
  const { state, set } = useSession();
  const inv = (state.refined?.investigations || []).filter((i) => state.selectedInv.includes(i.name));
  return (
    <div>
      <StepHeader num={6} title="Investigations" sub="Enter the investigation reports. Leave blank if pending." />
      <InvestigationPanel />
      {inv.length > 0 && <h2 className="font-heading text-lg font-semibold mt-10 mb-4">AI-ordered investigation results</h2>}
      <div className="grid md:grid-cols-2 gap-4">
        {inv.map((i, idx) => (
          <Field key={i.name} id={`result-${idx}`} label={i.name} value={state.results[i.name]} onChange={(x) => set("results", { ...state.results, [i.name]: x })} />
        ))}
      </div>
      <div className="mt-4"><Field id="other-results" label="Other reports / additional findings" multiline value={state.otherResults} onChange={(x) => set("otherResults", x)} /></div>
      <NavButtons onBack={() => set("step", 4)} onNext={() => set("step", 6)} nextLabel="Final diagnosis & treatment" />
    </div>
  );
}
